import { Button } from '@southfields-digital/mpxlive-components';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { StateType } from 'src/redux/reducers';
import { REQUEST_DELETE_PLAYLIST, REQUEST_DUPLICATE_PLAYLIST } from 'src/redux/reducers/playlist';

import type { PlaylistActionBarProps } from './PlaylistActionBar';

export default function DefaultActionBar({
  playlistId,
  editable,
  onToggleEditable,
  onAddGraphic,
  onEdit,
}: PlaylistActionBarProps) {
  const dispatch = useDispatch();

  const rundownId = useSelector((state: StateType) => state.rundown.detail.data?.id);

  const handleDuplicate = useCallback(() => {
    if (!playlistId || !rundownId) return;
    dispatch({
      type: REQUEST_DUPLICATE_PLAYLIST,
      payload: { id: playlistId, rundownId },
    });
  }, [dispatch, playlistId, rundownId]);

  const handleDelete = useCallback(() => {
    if (!playlistId) return;
    dispatch({
      type: REQUEST_DELETE_PLAYLIST,
      payload: { id: playlistId },
    });
  }, [dispatch, playlistId]);

  const handleToggleEditable = useCallback(() => {
    onToggleEditable?.(!editable);
  }, [onToggleEditable, editable]);

  return (
    <div className="flex gap-3 w-full h-fit items-center justify-between">
      <Button
        iconProps={{
          icon: editable ? 'lock-key-open' : 'lock-key',
          weight: 'bold',
        }}
        color={editable ? 'darkGray' : 'primary'}
        onClick={handleToggleEditable}
        title={editable ? 'Lock playlist' : 'Unlock playlist'}
      />
      <div className="flex gap-1">
        <Button
          iconProps={{ icon: 'plus', weight: 'bold' }}
          disabled={!editable}
          onClick={onAddGraphic}
          title="Add graphic"
        />
        <Button
          iconProps={{ icon: 'pencil', weight: 'bold' }}
          disabled={!editable || !playlistId}
          onClick={onEdit}
          title="Rename playlist"
        />
        <Button
          iconProps={{ icon: 'copy', weight: 'bold' }}
          disabled={!editable || !playlistId}
          onClick={handleDuplicate}
          title="Duplicate playlist"
        />
        <Button
          iconProps={{ icon: 'trash', weight: 'bold' }}
          disabled={!editable || !playlistId}
          onClick={handleDelete}
          title="Delete playlist"
        />
      </div>
    </div>
  );
}
